import { Link } from "react-router-dom";
import { PhoneCall, MapPin, Clock, Wrench } from "@phosphor-icons/react";
import { BUSINESS } from "../data/constants";
import { SERVICES } from "../data/services";
import { CITIES } from "../data/cities";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1B2A4A] text-white"
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 font-display font-black text-xl">
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-sm bg-white text-[#1B2A4A]">
              <Wrench size={20} weight="fill" className="text-[#FF6B00]" />
            </span>
            GTA <span className="text-[#FF6B00]">Garage</span> Doors
          </div>
          <p className="mt-4 text-sm text-white/70 leading-relaxed">
            24/7 emergency garage door and locksmith service across the
            Greater Toronto Area. Licensed. Insured. Fast.
          </p>
          <a
            href={BUSINESS.phoneHref}
            data-testid="footer-phone-link"
            className="mt-6 inline-flex items-center gap-2 text-[#FF6B00] font-display font-black text-xl phone-number hover:underline"
          >
            <PhoneCall size={22} weight="fill" />
            {BUSINESS.phone}
          </a>
        </div>

        <div>
          <div className="eyebrow !text-white/60">Services</div>
          <ul className="mt-4 space-y-2 text-sm">
            {SERVICES.slice(0, 8).map((s) => (
              <li key={s.slug}>
                <Link
                  to={`/services/${s.slug}`}
                  data-testid={`footer-service-${s.slug}`}
                  className="text-white/80 hover:text-[#FF6B00] transition-colors"
                >
                  {s.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="eyebrow !text-white/60">Service Areas</div>
          <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2 text-sm">
            {CITIES.map((c) => (
              <li key={c.slug}>
                <Link
                  to={`/areas/${c.slug}`}
                  data-testid={`footer-city-${c.slug}`}
                  className="text-white/80 hover:text-[#FF6B00] transition-colors"
                >
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="eyebrow !text-white/60">Contact</div>
          <ul className="mt-4 space-y-3 text-sm">
            <li className="flex items-start gap-2 text-white/80">
              <PhoneCall size={18} weight="fill" className="text-[#FF6B00] shrink-0 mt-0.5" />
              <a
                href={BUSINESS.phoneHref}
                data-testid="footer-contact-phone"
                className="hover:text-[#FF6B00] phone-number"
              >
                {BUSINESS.phone}
              </a>
            </li>
            <li className="flex items-start gap-2 text-white/80">
              <MapPin size={18} weight="fill" className="text-[#FF6B00] shrink-0 mt-0.5" />
              {BUSINESS.address}
            </li>
            <li className="flex items-start gap-2 text-white/80">
              <Clock size={18} weight="fill" className="text-[#FF6B00] shrink-0 mt-0.5" />
              Open 24 hours / 7 days a week
            </li>
          </ul>
          <div className="mt-6 eyebrow !text-white/60">Quick Links</div>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link to="/about" className="text-white/80 hover:text-[#FF6B00]" data-testid="footer-about-link">About Us</Link></li>
            <li><Link to="/contact" className="text-white/80 hover:text-[#FF6B00]" data-testid="footer-contact-link">Contact</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/60">
          <div>
            &copy; {new Date().getFullYear()} GTA Garage Doors & Locksmith. All
            rights reserved.
          </div>
          <div>Licensed & Insured &middot; Serving all of the GTA, 24/7</div>
        </div>
      </div>
    </footer>
  );
}
